<!--  -->
<template>
  <div>
    <div class="details_contentArea">
      <el-table
        v-loading="loading"
        :data="alltableData.list"
        max-height="500"
        border
        style="width: 100%; margin:0 auto;"
      >
        <el-table-column
          prop="admin_id"
          label="用户id"
          align="center"
        />
        <el-table-column
          prop="admin_name"
          label="用户名"
          align="center"
        />
        <el-table-column
          label="操作"
          align="center"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="chooserwe(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="alltableData.total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import { iaapitcherindexNative } from '@/api/TKreleaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      alltableData: {},
      pageinfo: {
        page: 1,
        page_size: 10,
        department_id: ''
      },
      loading: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(department_id) {
      console.log('department_id', department_id)
      this.pageinfo.department_id = department_id
      this.iaapitcherindexlist()
    },
    // 获取数据列表
    async iaapitcherindexlist() {
      this.loading = true
      const data = await iaapitcherindexNative(this.pageinfo)
      console.log('data', data)
      this.alltableData = data.data
      this.loading = false
    },
    fetchPageSize(s) {
      this.pageinfo.page_size = s
      this.iaapitcherindexlist()
    },

    fetchCurrentPage(s) {
      this.pageinfo.page = s
      this.iaapitcherindexlist()
    },
    chooserwe(item) {
      this.$emit('callbacktwo', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>

